import React, { useState } from "react";

const PointAllocation = () => {
  const data = [
    {
      heading: "Share a Social Media Post (1 Point):",
      para: "Share an existing Learn Local post or event on a personal account.",
    },
    {
      heading: "Engage with a Post (1 Point):",
      para: " Like, comment on, or tag others in a Learn Local post.",
    },
    {
      heading: "Follow Learn Local on Social Media (1 Point per Platform):",
      para: "Follow Learn Local’s accounts and encourage others to follow.",
    },
    {
      heading: "Invite a Friend to an Event (2 Points):",
      para: "Send a personal invitation to a Learn Local event or activity.",
    },
    {
      heading: "Create and Share a Post (3 Points):",
      para: "Post original content about Learn Local or a local learning experience.",
    },
    {
      heading: "1-3 Points",
      para: "Simple, quick tasks (e.g., sharing posts, liking content).",
    },
    {
      heading: "5-10 Points",
      para: " Moderate tasks requiring personal interaction or preparation (e.g., signing up a family, visiting a business).",
    },
    {
      heading: "15-20 Points",
      para: "High-impact tasks involving time, planning, and broader engagement (e.g., recruiting a business, organizing an event).",
    },
  ];
  const moderateEffort = [
    {
      heading: "Visit a Business and Share a Pic with a Message (8 Points):",
      para: "Stop by a business, connect with the owner, and post about the visit with an encouraging message.",
    },
    {
      heading: "Recruit a Family to Sign Up (5 Points):",
      para: " Help a family register for a Learn Local experience.",
    },
    {
      heading: "Submit Feedback on an Experience (5 Points):",
      para: "Provide detailed feedback about a Learn Local event or session.",
    },
    {
      heading: "Participate in an Online Q&A (5 Points):",
      para: "Join a live Q&A session to learn or share more about the program.",
    },
    {
      heading: "Assist in Designing a Learning Experience (10 Points):",
      para: "Collaborate with a business to plan an educational session or workshop.",
    },
    {
      heading: "1-3 Points",
      para: "Simple, quick tasks (e.g., sharing posts, liking content).",
    },
    {
      heading: "5-10 Points",
      para: " Moderate tasks requiring personal interaction or preparation (e.g., signing up a family, visiting a business).",
    },
    {
      heading: "15-20 Points",
      para: "High-impact tasks involving time, planning, and broader engagement (e.g., recruiting a business, organizing an event).",
    },
  ];
  const highEffort = [
    {
      heading: "Sign Up a Business (15 Points):",
      para: "Successfully recruit a business to host a learning experience.",
    },
    {
      heading: "Attend an Event and Share Pics (15 Points):",
      para: "Participate in a Learn Local event and post about it on social media with at least three photos and a caption.",
    },
    {
      heading: "Recruit an Ambassador (15 Points):",
      para: "Bring a new ambassador on board, including providing guidance on the role.",
    },
    {
      heading: "Lead a Volunteer Info Session (20 Points):",
      para: "Host an information session for potential ambassadors or families.",
    },
    {
      heading: "Organize a Community Event (20 Points):",
      para: "Coordinate a small event or workshop that aligns with Learn Local’s mission.",
    },
    {
      heading: "1-3 Points",
      para: "Simple, quick tasks (e.g., sharing posts, liking content).",
    },
    {
      heading: "5-10 Points",
      para: " Moderate tasks requiring personal interaction or preparation (e.g., signing up a family, visiting a business).",
    },
    {
      heading: "15-20 Points",
      para: "High-impact tasks involving time, planning, and broader engagement (e.g., recruiting a business, organizing an event).",
    },
  ];
 const extraTasks = [
    {
      heading: "Write a Blog or Testimonial (10 Points):",
      para: "Contribute a written piece about your Learn Local experience or a successful session.",
    },
    {
      heading: "Collaborate on Marketing Content (10 Points):",
      para: "Help design flyers, graphics, or other promotional materials.",
    },
    {
      heading: "Record a Video Testimonial (15 Points):",
      para: "Share your experience as an ambassador in a short video for Learn Local to use on its platforms.",
    },
    {
      heading: "Support New Ambassadors (10 Points)",
      para: "Act as a mentor for newly recruited ambassadors, guiding them through their first few tasks.",
    },
    {
      heading: "Partner with a Local Organization (20 Points):",
      para: "Establish a partnership between Learn Local and a local school, nonprofit, or community group.",
    },
    {
      heading: "1-3 Points",
      para: "Simple, quick tasks (e.g., sharing posts, liking content).",
    },
    {
      heading: "5-10 Points",
      para: " Moderate tasks requiring personal interaction or preparation (e.g., signing up a family, visiting a business).",
    },
    {
      heading: "15-20 Points",
      para: "High-impact tasks involving time, planning, and broader engagement (e.g., recruiting a business, organizing an event).",
    },
  ];
  const [activeTab, setActiveTab] = useState("Low Effort Task");
  return (
    <div>
      <div className="w-full mb-6">
        <h1 className="text-2xl text-blackie font-semibold">
          Point Allocation
        </h1>
      </div>
      <div className="flex justify-start mb-6">
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "Low Effort Task"
              ? "text-yellowText border-b-2 border-yellowText"
              : "text-grayText"
          }`}
          onClick={() => setActiveTab("Low Effort Task")}
        >
          Low Effort Task
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "Moderate Effort Task"
              ? "text-yellowText border-b-2 border-yellowText"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("Moderate Effort Task")}
        >
          Moderate Effort Task
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "High Effort Task"
              ? "text-yellowText border-b-2 border-yellowText"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("High Effort Task")}
        >
          High Effort Task
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "Extra Tasks & Matrics"
              ? "text-yellowText border-b-2 border-yellowText"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("Extra Tasks & Matrics")}
        >
          Extra Tasks & Matrics
        </button>
      </div>
      {activeTab === "Low Effort Task" && (
        <>
        <h4 className="font-semibold">Low Effort Tasks (1-3 Points)</h4>
        <div className="flex flex-col md:flex-row gap-4 py-4">
          <div className="md:w-3/5 space-y-4">
            {data.slice(0, 5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>

          <div className="md:w-3/5 space-y-4">
            {data.slice(5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        </>
      )}
      {activeTab === "Moderate Effort Task" && (
         <>
        <h4 className="font-semibold">Moderate Effort Tasks (4-10 Points)</h4>
        <div className="flex flex-col md:flex-row gap-4 py-4">
          <div className="md:w-3/5 space-y-4">
            {moderateEffort.slice(0, 5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>

          <div className="md:w-3/5 space-y-4">
            {data.slice(5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
         </>
      )}
      {activeTab === "High Effort Task" && (
             <>
        <h4 className="font-semibold">High Effort Tasks (11-20 Points)</h4>
        <div className="flex flex-col md:flex-row gap-4 py-4">
          <div className="md:w-3/5 space-y-4">
            {highEffort.slice(0, 5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>

          <div className="md:w-3/5 space-y-4">
            {data.slice(5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
           </>
      )}
      {activeTab === "Extra Tasks & Matrics" && (
           <>
        <h4 className="font-semibold">Extra Tasks and Metrics</h4>
        <div className="flex flex-col md:flex-row gap-4 py-4">
          <div className="md:w-3/5 space-y-4">
            {extraTasks.slice(0, 5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>

          <div className="md:w-3/5 space-y-4">
            {data.slice(5).map((item, index) => (
              <div key={index}>
                <p className="font-semibold">{item.heading}</p>
                <ul className="list-disc list-inside ml-4 text-blackie-700">
                  <li>{item.para}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default PointAllocation;
